<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <vs-row
      vs-w="12"
      class="mt-5 filter-container flex justify-between"
    >
      <vs-col vs-w="1">
        <p class="font-semibold">
          Filter
        </p>
      </vs-col>
      <vs-col vs-w="2" />
      <vs-col
        vs-w="9"
        class="flex justify-end"
      >
        <div class="flex flex-row gap-x-4">
          <div class="flex items-center w-full">
            <date-picker
              format="DD MMM YYYY"
              style="min-width: 260px;"
              value-type="format"
              type="date"
              placeholder="Select Date"
              v-model="filters.date"
              range
            />
          </div>
          <div class="flex items-center w-full">
            <select-with-multiple
              v-model="filters.owner_id"
              style="min-width: 260px;"
              placeholder="Select owner name"
              :options="ownerOptions"
              :activate-search="true"
            />
          </div>
          <div class="flex items-center">
            <vs-button
              type="border"
              color="primary"
              class="self-center font-semibold"
              style="min-width: 100px;"
              @click="() => {
                $refs.tableTop.$emit('reset-search')
                filters = $options.data().filters
                fetchQuarterlyInspection()
              }"
            >
              Reset
            </vs-button>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
      <table-top
        is-search-has-border
        :page-size-start="false"
        class="mt-6"
        @fetch="fetchQuarterlyInspection"
        ref="tableTop"
      >
        <template #start>
          <div
            class="flex items-center justify-center"
          >
            <vs-button
              class="button w-max font-semibold"
              color="primary"
              @click="onHandleAdd"
              v-show="isUserCanAdd"
            >
              Add Quarterly Inspection
            </vs-button>
            <vs-button
              class="button w-max font-semibold ml-5"
              color="secondary"
              v-show="isUserCanView"
              @click="isDownload = true"
              :disabled="isDownload || filters.date.some(v => isEmpty(v))"
            >
              Export
            </vs-button>
            <vs-button
              :class="`button w-min font-semibold ml-5 ${isBusy && 'cursor-not-allowed opacity-50 animate-bounce'}`"
              :disabled="isBusy"
              color="secondary"
              @click="sendQuarterlyInspectionEmail"
            >
              Send Email
            </vs-button>
          </div>
        </template>
      </table-top>
      <data-table
        class="mt-6"
        :table-header="tableHeader"
        :table-data="tableData"
        :sort-by="filters.sort_by"
        :sort-dir="filters.sort_dir"
        :frozen-columns="0"
        :grouped-headers="groupHeader"
        :loading="isBusy"
        body-height="auto"
        @sort="sort"
      >
        <template #no="{ index }">
          <div class="flex flex-row">
            {{ (currentPage - 1) * pageSize + index + 1 }}
          </div>
        </template>
        <template #action="{ row }">
          <div class="flex flex-row">
            <template>
              <div
                v-if="isUserCanView"
                :class="`mx-1 self-center flex items-center justify-center icon-transparent-bg ${isProcessing && quarterlyInspectionsId === row.id && 'cursor-not-allowed opacity-50 animate-bounce'}`"
                @click="isProcessing && quarterlyInspectionsId === row.id ? null : onHandleView(row)"
              >
                <img :src="require('@/assets/shipo-icon-see.svg')">
              </div>
              <div
                v-if="isUserCanEdit"
                :class="`mx-1 self-center flex items-center justify-center icon-transparent-bg ${isProcessing && quarterlyInspectionsId === row.id && 'cursor-not-allowed opacity-50 animate-bounce'}`"
                @click=" isProcessing && quarterlyInspectionsId === row.id ? null :onHandleEdit(row)"
              >
                <img :src="require('@/assets/shipo-icon-edit.svg')">
              </div>
              <div
                v-if="isUserCanView"
                class="mx-1 self-center flex items-center justify-center icon-transparent-bg"
                @click="() => {
                  idDownload = row.id
                  isDownloadFile = true
                }"
              >
                <img :src="require('@/assets/shipo-icon-download-2.svg')">
              </div>
              <div
                v-if="isUserCanDelete"
                class="mx-1 flex items-center justify-center icon-transparent-bg"
                @click="onHandleDelete(row)"
              >
                <img :src="require('@/assets/shipo-icon-delete.svg')">
              </div>
            </template>
          </div>
        </template>
        <template #inspection_date="{ row }">
          {{ moment(row.inspection_date).format('DD MMM YYYY') }}
        </template>
        <template #is_good="{ row }">
          <vs-icon
            icon="check_circle"
            :color="row.is_good ? '#15AF59' : '#DADADA'"
            size="small"
          />
        </template>
        <template #is_fair="{ row }">
          <vs-icon
            icon="check_circle"
            :color="row.is_fair ? '#FFAA00' : '#DADADA'"
            size="small"
          />
        </template>
        <template #is_poor="{ row }">
          <vs-icon
            icon="check_circle"
            :color="row.is_poor ? '#EE443F' : '#DADADA'"
            size="small"
          />
        </template>
        <template #is_anchor_active="{ row }">
          <vs-icon
            icon="check_circle"
            :color="row.is_anchor_active ? '#15AF59' : '#DADADA'"
            size="small"
          />
        </template>
        <template #is_anchor_inactive="{ row }">
          <vs-icon
            icon="check_circle"
            :color="row.is_anchor_inactive ? '#EE443F' : '#DADADA'"
            size="small"
          />
        </template>
      </data-table>
      <table-bottom
        class="mt-6"
        @fetch="fetchQuarterlyInspection"
      />
    </div>
    <pop-up
      is-warning
      title="Delete Quarterly Inspection"
      left-button="Cancel"
      right-button="Yes, Delete"
      :active.sync="popUp.isShown"
      :is-busy="isProcessing"
      @close="popUp = $options.data().popUp"
      @leftButton="popUp = $options.data().popUp"
      @rightButton="deleteQuarterlyInspection"
    >
      <p class="text-center mt-1">
        Are you sure you want to delete inspection of<br>
        <b>Tug</b> {{ popUp.tugName }} -- <b>Barge</b> {{ popUp.bargeName }}
        <br> at <b>{{ popUp.inspectionDate }}</b>
        ?
      </p>
      <p class="text-center">
        This action cannot be undone
      </p>
    </pop-up>
    <modal-form
      v-if="modalOpen"
      :active="true"
      @close="() => {
        modalOpen = false
        fetchQuarterlyInspection()
      }"
      :owner-options="ownerOptions"
      :is-view="isView"
      :is-adding="isAdding"
      :id="quarterlyInspectionsId"
      @handle-download="downloadFileQuarterlyInspection"
      @open-preview="onHandlePreview"
    />
    <modal-preview-img
      title="Image Preview"
      :active.sync="modalPreviewOpen"
      :images="images"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import DatePicker from "@/components/datePicker";
import PopUp from '@/components/popUp'
import SelectWithMultiple from '@/components/selectWithMultiple';
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'
import downloadUtils from '@/utils/downloadUtils'

import ModalForm from './ModalForm.vue';
import ModalPreviewImg from './ModalPreviewImg.vue';

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  components: {
    TableBottom,
    TableTop,
    DataTable,
    SelectWithMultiple,
    PopUp,
    ModalForm,
    DatePicker,
    ModalPreviewImg
  },
  data() {
    return {
      isBusy: false,
      filters: {
        date: [
          moment().startOf('year').format('DD MMM YYYY'),
          moment().endOf('year').format('DD MMM YYYY')
        ],
        owner_id: [],
        sort_by: 'inspection_date',
        sort_dir: 'DESC'
      },
      popUp: {
        isShown: false,
        tempId: null,
        tempName: null
      },
      tableHeader: [
        { key: 'no', label: 'No', width: '50px', freeze: false },
        { key: 'action', label: 'Action', freeze: false },
        { key: 'inspection_date', label: 'Inspection Date', sortable: true, freeze: false },
        { key: 'tug_name', label: 'Tug Name', sortable: true, freeze: false },
        { key: 'barge_name', label: 'Barge Name', sortable: true, freeze: false },
        { key: 'owner_name', label: 'Owner', sortable: true, freeze: false },
        { key: 'status_on_hire', label: 'Contract', sortable: true, freeze: false },
        { key: 'is_good', label: 'Good', sortable: true, freeze: false, group: 'Barge Assesment' },
        { key: 'is_fair', label: 'Fair', sortable: true, freeze: false, group: 'Barge Assesment' },
        { key: 'is_poor', label: 'Poor', sortable: true, freeze: false, group: 'Barge Assesment' },
        { key: 'total_points', label: 'Total Points', sortable: true, freeze: false },
        { key: 'is_anchor_active', label: 'Active', sortable: true, freeze: false, group: 'Anchor' },
        { key: 'is_anchor_inactive', label: 'Inactive', sortable: true, freeze: false, group: 'Anchor' }
      ],
      groupHeader: [
        {
          title: 'Barge Assesment',
          startColumn: 'is_good',
          endColumn: 'is_poor',
          backgroundColor: ''
        },
        {
          title: 'Anchor',
          startColumn: 'is_anchor_active',
          endColumn: 'is_anchor_inactive',
          backgroundColor: ''
        }
      ],
      tableData: [],
      ownerOptions: [],
      isDownload: false,
      isDownloadFile: false,
      idDownload: '',
      isAdding: false,
      modalOpen: false,
      quarterlyInspectionsId: '',
      isView: false,
      popUpSuccess: false,
      modalPreviewOpen: false,
      images: [],
      isProcessing: false
    }
  },
  computed: {
    ...mapGetters({
      quarterlyInspections: 'QuarterlyInspection/quarterlyInspections',
      totalPage: 'Table/totalPage',
      totalData: 'Table/totalData',
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      owners: 'TugManagement/owners',
      quarterlyInspectionFiles: 'QuarterlyInspection/quarterlyInspectionFiles',
      fileExport: 'QuarterlyInspection/fileExport'
    }),
    isUserCanView() {
      return this.isUserCanAccessMenu(this.permission.name, 'view')
    },
    isUserCanAdd() {
      return this.isUserCanAccessMenu(this.permission.name, 'add')
    },
    isUserCanEdit() {
      return this.isUserCanAccessMenu(this.permission.name, 'edit')
    },
    isUserCanDelete() {
      return this.isUserCanAccessMenu(this.permission.name, 'delete')
    },
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    quarterlyInspections: {
      handler(val) {
        if (val) {
          this.tableData = val.data
        }
      }
    },
    owners: {
      handler(val) {
        if (val) {
          this.ownerOptions = val.map(item => ({
            text: item.owner_name,
            value: item.owner_id
          }));
        }
      }
    },
    filters: {
      handler() {
        if (!this.filters.date.some(v => this.isEmpty(v))) {
          const base = this.moment(this.filters.date[1])
          const minDate = base.clone().subtract(1, 'year')
          const maxDate = base.clone().add(1, 'year')

          if (this.moment(this.filters.date[0]).isBefore(minDate, 'day') || this.moment(this.filters.date[0]).isAfter(maxDate, 'day')) {
            this.showFailedNotification(this, 'Can be selected with a maximum range of 1 year')
            this.filters.date = [
              this.moment().startOf('year').format('DD MMM YYYY'),
              this.moment().endOf('year').format('DD MMM YYYY')
            ]
            return
          }
        }
        this.fetchQuarterlyInspection();
      },
      deep: true
    },
    isDownload: {
      handler(val) {
        if (val) {
          this.exportQuarterlyInspection()
        }
      }
    },
    isDownloadFile: {
      handler(val) {
        if (val) {
          this.downloadFileQuarterlyInspection()
        }
      }
    },
    quarterlyInspectionFiles: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(val, `QuarterlyInspectionDetail.xlsx`)
          this.$store.dispatch('QuarterlyInspection/resetFile')
          this.isDownloadFile = false
        }
      }
    },
    fileExport: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(val, `QuarterlyInspection.xlsx`)
          this.$store.dispatch('QuarterlyInspection/resetFileExport')
          this.idDownload = ''
          this.isDownload = false
        }
      }
    }
  },
  async mounted() {
    if (this.$route.query.start_date || this.$route.query.end_date) {
      try {
        const startDate = this.$route.query.start_date
        const endDate = this.$route.query.end_date
        
        if (startDate && endDate) {
          const parsedStartDate = moment(startDate, 'YYYY-MM-DD')
          const parsedEndDate = moment(endDate, 'YYYY-MM-DD')
          
          if (parsedStartDate.isValid() && parsedEndDate.isValid()) {
            this.filters.date = [
              parsedStartDate.format('DD MMM YYYY'),
              parsedEndDate.format('DD MMM YYYY')
            ]
          } else {
            this.showFailedNotification(this, 'Invalid date parameter format, please try again')
          }
        } else {
          this.showFailedNotification(this, 'Both start_date and end_date are required')
        }
      } catch (e) {
        this.showFailedNotification(this, 'Invalid date parameter format, please try again')
      }
    }
    this.fetchOwnerOptions()
  },
  methods: {
    async exportQuarterlyInspection() {
      try {
        this.isBusy = true
        await this.$store.dispatch('QuarterlyInspection/exportQuarterlyInspection', {
          owner_id: this.filters.owner_id.length ? this.filters.owner_id.map(v => v.value).join() : null,
          start_date: this.moment(this.filters.date[0]).format('YYYY-MM-DD'),
          end_date: this.moment(this.filters.date[1]).format('YYYY-MM-DD')
        }, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          resposnseType: 'blob'
        })
        this.isDownload = false
        this.isBusy = false
      } catch (error) {
        this.isDownload = false
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to download export, please try again')
      }
    },
    async downloadFileQuarterlyInspection() {
      try {
        this.isBusy = true
        await this.$store.dispatch('QuarterlyInspection/downloadQuarterlyInspection', this.idDownload, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          resposnseType: 'blob'
        })
        this.isDownloadFile = false
        this.isBusy = false
      } catch (error) {
        this.isDownloadFile = false
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to download export, please try again')
      }
    },
    async fetchOwnerOptions() {
      this.isProcessing = true
      await this.$store.dispatch('TugManagement/fetchOwners')
      this.isProcessing = false
    },
    async fetchQuarterlyInspection() {
      try {
        this.isBusy = true
        this.tableData = []
        const apiFilters = {
          sort_dir: this.filters.sort_dir || 'DESC',
          sort_by: this.filters.sort_by || 'inspection_date',
          page: this.currentPage,
          limit: this.pageSize,
          owner_id: this.filters.owner_id.length ? this.filters.owner_id.map(v => v.value).join() : null,
          start_date: this.filters?.date?.[0] ? this.moment(this.filters.date[0]).format('YYYY-MM-DD') : null,
          end_date: this.filters?.date?.[1] ? this.moment(this.filters.date[1]).format('YYYY-MM-DD') : null
        };

        const isFilter = [
          'is_good',
          'is_fair',
          'is_poor',
          'is_anchor_active',
          'is_anchor_inactive'
        ]

        if (isFilter.includes(apiFilters.sort_by)) {
          apiFilters.sort_dir = apiFilters.sort_dir === 'desc' ? 'asc' : 'desc'
        }

        await this.$store.dispatch('QuarterlyInspection/fetchQuarterlyInspections', apiFilters)

        this.isAdding = false
        this.isBusy = false
      } catch (e) {
        this.isAdding = false
        this.isBusy = false
        this.showFailedNotification(this, 'Request failed (CORS or network issue).')
      }
    },
    onHandleAdd() {
      this.isAdding = true
      this.isView = false
      this.quarterlyInspectionsId = ''
      this.modalOpen = true
    },
    onHandleSubmit(row) {},
    onHandleEdit(row) {
      this.isAdding = false
      this.isView = false
      this.quarterlyInspectionsId = `${row.id}`
      this.modalOpen = true
    },
    onHandleView(row) {
      this.idDownload = row.id
      this.isAdding = false
      this.isView = true
      this.quarterlyInspectionsId = `${row.id}`
      this.modalOpen = true
    },
    onHandleDelete(row) {
      this.popUp = { isShown: true, tempId: row.id, tugName: row.tug_name, bargeName: row.barge_name, inspectionDate: moment(row.inspection_date).format('DD MMM YYYY') }
    },
    async deleteQuarterlyInspection() {
      try {
        this.isProcessing = true
        await this.$store.dispatch('QuarterlyInspection/deleteQuarterlyInspection', this.popUp.tempId)
        this.isProcessing = false
        this.popUp = this.$options.data().popUp
        this.showSuccessNotification(this, 'Quarterly Inspection successfully deleted.')
        this.fetchQuarterlyInspection()
      } catch (e) {
        this.isProcessing = false
        this.showFailedNotification(this, 'Request failed (CORS or network issue).')
      }
    },
    sort(sortBy, sortDir) {
      this.filters.sort_by = sortBy;
      this.filters.sort_dir = sortDir;
      this.fetchQuarterlyInspection();
    },
    async resetTableFilter() {
      await this.$store.dispatch('Table/resetConfig')
      await this.fetchQuarterlyInspection()
      this.popUpSuccess = false
    },
    async sendQuarterlyInspectionEmail() {
      this.isBusy = true
      try {
        await this.$store.dispatch('QuarterlyInspection/postQuarterlyInspectionSendEmail', {
          ...(this.filters.owner_id.length ? { owner_id: this.filters.owner_id.map(v => v.value.toString()) } : null),
          ...(this.filters.date.length ? {
            start_date: this.moment(this.filters.date[0]).format('YYYY-MM-DD'),
            end_date: this.moment(this.filters.date[1]).format('YYYY-MM-DD')
          } : null)
        })

        this.showSuccessNotification(this, 'Quarterly inspection email successfully sent')
      } catch ({ data }) {
        const message = data?.error?.message || 'Failed to send quarterly inspection email, please try again'
        this.showFailedNotification(this, message)
      } finally {
        this.isBusy = false
      }
    },
    onHandlePreview(val) {
      this.images = val
      this.modalPreviewOpen = true
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  @apply p-5 mt-5 flex flex-row items-center bg-white rounded-lg;
}
</style>
